import { cn } from "../lib/cn";

import type { TierName } from "../constants";

export type BadgeVariant = "success" | "warning" | "error" | "info";

export interface BadgeProps {
  tier?: TierName;
  variant?: BadgeVariant;
  className?: string;
  children: React.ReactNode;
}

const tierColors: Record<TierName, string> = {
  Unverified: "bg-[#4a4a4a]/10 text-[#4a4a4a] border-l-[#4a4a4a]",
  Basic: "bg-[#8b5e3c]/10 text-[#8b5e3c] border-l-[#8b5e3c]",
  Verified: "bg-[#a0a0a8]/10 text-[#a0a0a8] border-l-[#a0a0a8]",
  Trusted: "bg-[#C9A84C]/10 text-[#C9A84C] border-l-[#C9A84C]",
  Sovereign: "bg-amber/10 text-amber border-l-amber",
};

const variantColors: Record<BadgeVariant, string> = {
  success: "bg-success/20 text-success border-success/30",
  warning: "bg-warning/20 text-warning border-warning/30",
  error: "bg-error/20 text-error border-error/30",
  info: "bg-info/20 text-info border-info/30",
};

export function Badge({ tier, variant, className, children }: BadgeProps) {
  const colorClass = tier
    ? tierColors[tier]
    : variant
      ? variantColors[variant]
      : "bg-gold-dim text-gold border-gold/30";

  return (
    <span
      className={cn(
        "inline-flex items-center border-l-[3px] px-[7px] py-[2.5px] font-mono text-[7.5px] uppercase tracking-[0.10em]",
        colorClass,
        className,
      )}
    >
      {children}
    </span>
  );
}
